import { StringMap } from 'components/views/company/outreach-template/message-bank.context';
import { FieldPath } from 'react-hook-form/dist/types/path/eager';
import { CreateTcrCampaignVariables } from 'types/apollo/CreateTcrCampaign';
import { CreateTcrCampaignInput } from 'types/apollo/globalTypes';
import { PropertyOfType } from 'utils/typings';

export interface TcrCardProps {
  campaignId: string;
  internalCampaignId: string;
}

export const Cnp = {
  Telnyx: 'SS4XJ6D',
};

export const defaultValues: CreateTcrCampaignVariables = {
  campaignId: '',

  input: {
    brandId: '',

    usecase: 'MARKETING',
    subUsecases: [],

    subscriberOptin: true,
    subscriberOptout: true,
    subscriberHelp: true,
    numberPool: false,
    directLending: false,

    embeddedLink: false,
    embeddedPhone: false,
    ageGated: false,
    affiliateMarketing: false,

    mnos: [],
    upstreamCnpId: Cnp.Telnyx,
  },

  editableFields: {
    description: 'To send marketing messages about .......',
    messageFlow: '',

    helpKeywords: 'HELP',
    optinKeywords: 'START',
    optoutKeywords: 'STOP',

    helpMessage: 'We do not have a predefined help message',
    optoutMessage:
      'You have successfully been unsubscribed, you will not receive any more messages from this number. Reply START to re-subscribe.',

    sample1: '',
    sample2: '',
    sample3: '',
    sample4: '',
  },
};

export const helperTexts: Record<
  FieldPath<CreateTcrCampaignInput> & PropertyOfType<CreateTcrCampaignInput, boolean>,
  string
> = {
  numberPool:
    'Select this if you intend on using 50+ numbers as this will require a different provisioning process on T-Mobile',
  ageGated:
    'Will this campaign include any age-gated content as defined by Carrier and CTIA guidelines?',
  affiliateMarketing:
    'Affiliate marketing is NOT allowed. The campaign will be rejected if you check this.',
  directLending:
    'Will this campaign include content related to direct lending or other loan arrangements?',
  embeddedLink:
    'Are you using an embedded link of any kind? Note that public URL shorteners (bitly, tinyurl) are not accepted.',
  embeddedPhone:
    'Are you using an embedded phone number (except the required HELP information contact phone number)?',
  subscriberOptin: 'You are collecting and processing consumer opt-ins.',
  subscriberOptout: 'You are collecting and processing consumer opt-outs.',
  subscriberHelp:
    'You have implemented message reply providing customers on how they can contact the message sender after they reply with the "HELP" keyword. NOTE: Aktify does not explicitly implement this right now',
};

export const applyReplacements = (replacements: StringMap, text: string) => {
  const textArray = text.split(/([\s+\\.,'\-\\(\\);!?])/);

  const result = textArray.map((part) => replacements[part] ?? part);
  return result.join('');
};
